import { Box } from '@mui/material'
import { Shopify } from './IntegrationData/components/Shopify'

type Props = {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function IntegrationData(props: Props) {
  const { extOrder } = props
  const integrationData = extOrder.order.integrationData

  if (!integrationData) {
    return null
  }

  switch (integrationData.integrationType) {
    case 'SHOPIFY':
      return (
        <Box>
          <Shopify integrationData={integrationData} />
        </Box>
      )

    case 'ZAPIER':
      // Zapier integration data exists but no specific display needed yet
      return null

    default:
      return null
  }
}
